type FeatureConfig = { [layerId: string]: { [featureId: string]: GeoJSON.Feature } | undefined };

export function getRollupCount(config: FeatureConfig, layerIds: string[]): number {
  let count = 0;
  layerIds.forEach((layerId) => {
    const features = config[layerId];
    if (features) {
      count += Object.keys(features).length;
    }
  });
  return count;
}
